var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _circle173, _circle174, _circle175, _circle176, _circle177, _circle178, _circle179, _circle180;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBubbleWrap = function SvgBubbleWrap(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M559.57 183.89H305.72a7 7 0 0 0-7 7v11a10.24 10.24 0 1 1 0 20.47v8.28a10.24 10.24 0 1 1 0 20.47v8.29a10.24 10.24 0 1 1 0 20.47v8.28a10.24 10.24 0 1 1 0 20.47v8.29a10.24 10.24 0 1 1 0 20.47v8.28a10.24 10.24 0 1 1 0 20.47v8.28a10.24 10.24 0 0 1 0 20.48v12.66a7 7 0 0 0 7 7h253.85a7 7 0 0 0 7-7v-22.9a10.24 10.24 0 1 1-10.24-10.24 10.25 10.25 0 0 1 10.24 10.24v-28.76a10.24 10.24 0 1 1-10.24-10.24 10.24 10.24 0 0 1 10.24 10.24v-28.76a10.24 10.24 0 1 1-10.24-10.23 10.25 10.25 0 0 1 10.24 10.23v-28.75a10.24 10.24 0 1 1-10.24-10.24 10.24 10.24 0 0 1 10.24 10.24v-28.76a10.24 10.24 0 1 1-10.24-10.23 10.24 10.24 0 0 1 10.24 10.23v-28.75a10.24 10.24 0 1 1-10.24-10.24 10.24 10.24 0 0 1 10.24 10.24v-28.76a10.24 10.24 0 1 1-10.24-10.23 10.24 10.24 0 0 1 10.24 10.23v-21.22a7 7 0 0 0-7-7zm-45 18a10.24 10.24 0 1 1-10.24 10.23 10.23 10.23 0 0 1 10.2-10.24zm0 28.75a10.24 10.24 0 1 1-10.24 10.24 10.23 10.23 0 0 1 10.2-10.25zm0 28.76a10.24 10.24 0 1 1-10.24 10.23 10.23 10.23 0 0 1 10.2-10.24zm0 28.75a10.24 10.24 0 1 1-10.24 10.24 10.23 10.23 0 0 1 10.2-10.25zm0 28.76a10.24 10.24 0 1 1-10.24 10.23 10.23 10.23 0 0 1 10.2-10.24zm0 28.75a10.24 10.24 0 1 1-10.24 10.24 10.23 10.23 0 0 1 10.2-10.25zm-85.3-143.77A10.24 10.24 0 1 1 419 212.11a10.23 10.23 0 0 1 10.23-10.23zm0 28.75A10.24 10.24 0 1 1 419 240.87a10.23 10.23 0 0 1 10.23-10.24zm0 28.76A10.24 10.24 0 1 1 419 269.62a10.23 10.23 0 0 1 10.23-10.23zm0 28.75A10.24 10.24 0 1 1 419 298.38a10.23 10.23 0 0 1 10.23-10.24zm0 28.76A10.24 10.24 0 1 1 419 327.13a10.23 10.23 0 0 1 10.23-10.23zm0 28.75A10.24 10.24 0 1 1 419 355.89a10.23 10.23 0 0 1 10.23-10.24zm-85.35-143.78a10.24 10.24 0 1 1-10.23 10.23 10.23 10.23 0 0 1 10.23-10.23zm0 28.75a10.24 10.24 0 1 1-10.23 10.24 10.23 10.23 0 0 1 10.23-10.24zm0 28.76a10.24 10.24 0 1 1-10.23 10.23 10.23 10.23 0 0 1 10.23-10.23zm0 28.75a10.24 10.24 0 1 1-10.23 10.24 10.23 10.23 0 0 1 10.23-10.24zm0 28.76a10.24 10.24 0 1 1-10.23 10.23 10.23 10.23 0 0 1 10.23-10.23zm0 28.75a10.24 10.24 0 1 1-10.23 10.24 10.23 10.23 0 0 1 10.23-10.24zm-21.33 62.75a10.24 10.24 0 1 1 10.24-10.23 10.23 10.23 0 0 1-10.24 10.23zm0-28.75a10.24 10.24 0 1 1 10.24-10.24 10.24 10.24 0 0 1-10.24 10.24zm0-28.76a10.24 10.24 0 1 1 10.24-10.23 10.23 10.23 0 0 1-10.24 10.23zm0-28.75a10.24 10.24 0 1 1 10.24-10.24 10.24 10.24 0 0 1-10.24 10.24zm0-28.76a10.24 10.24 0 1 1 10.24-10.23 10.23 10.23 0 0 1-10.24 10.23zm0-28.75a10.24 10.24 0 1 1 10.24-10.24 10.23 10.23 0 0 1-10.24 10.24zm0-28.76a10.24 10.24 0 1 1 10.24-10.23 10.23 10.23 0 0 1-10.24 10.23zm0-28.75a10.24 10.24 0 1 1 10.24-10.24 10.23 10.23 0 0 1-10.24 10.24zm21.33 187.76a10.24 10.24 0 1 1 10.24-10.24 10.24 10.24 0 0 1-10.24 10.24zm20.48 13.52a10.24 10.24 0 1 1 10.23-10.23 10.23 10.23 0 0 1-10.23 10.23zm0-28.75a10.24 10.24 0 1 1 10.23-10.24 10.24 10.24 0 0 1-10.23 10.24zm0-28.76a10.24 10.24 0 1 1 10.23-10.23 10.23 10.23 0 0 1-10.23 10.23zm0-28.75a10.24 10.24 0 1 1 10.23-10.24 10.24 10.24 0 0 1-10.23 10.24zm0-28.76a10.24 10.24 0 1 1 10.23-10.23 10.23 10.23 0 0 1-10.23 10.23zm0-28.75a10.24 10.24 0 1 1 10.23-10.24 10.23 10.23 0 0 1-10.23 10.24zm0-28.76a10.24 10.24 0 1 1 10.23-10.23 10.23 10.23 0 0 1-10.23 10.23zm0-28.75a10.24 10.24 0 1 1 10.23-10.24 10.23 10.23 0 0 1-10.23 10.24zm21.33 187.76A10.24 10.24 0 1 1 396 384.64a10.25 10.25 0 0 1-10.27 10.24zm0-28.76A10.24 10.24 0 1 1 396 355.89a10.24 10.24 0 0 1-10.27 10.23zm0-28.75A10.24 10.24 0 1 1 396 327.13a10.25 10.25 0 0 1-10.27 10.24zm0-28.76A10.24 10.24 0 1 1 396 298.38a10.24 10.24 0 0 1-10.27 10.23zm0-28.75A10.24 10.24 0 1 1 396 269.62a10.24 10.24 0 0 1-10.27 10.24zm0-28.76A10.24 10.24 0 1 1 396 240.87a10.24 10.24 0 0 1-10.27 10.23zm0-28.75A10.24 10.24 0 1 1 396 212.11a10.24 10.24 0 0 1-10.27 10.24zm22.16 186a10.24 10.24 0 1 1 10.24-10.23 10.23 10.23 0 0 1-10.24 10.28zm0-28.75a10.24 10.24 0 1 1 10.24-10.24 10.24 10.24 0 0 1-10.24 10.29zm0-28.76a10.24 10.24 0 1 1 10.24-10.23 10.23 10.23 0 0 1-10.24 10.28zm0-28.75a10.24 10.24 0 1 1 10.24-10.24 10.24 10.24 0 0 1-10.24 10.29zm0-28.76a10.24 10.24 0 1 1 10.24-10.23 10.23 10.23 0 0 1-10.24 10.28zm0-28.75a10.24 10.24 0 1 1 10.24-10.24 10.23 10.23 0 0 1-10.24 10.29zm0-28.76a10.24 10.24 0 1 1 10.24-10.23 10.23 10.23 0 0 1-10.24 10.28zm0-28.75a10.24 10.24 0 1 1 10.24-10.24 10.23 10.23 0 0 1-10.24 10.29zm21.34 187.76a10.24 10.24 0 1 1 10.23-10.24 10.24 10.24 0 0 1-10.23 10.29zm20.47 13.57a10.24 10.24 0 1 1 10.23-10.23 10.23 10.23 0 0 1-10.23 10.23zm0-28.75a10.24 10.24 0 1 1 10.23-10.24 10.24 10.24 0 0 1-10.23 10.24zm0-28.76a10.24 10.24 0 1 1 10.23-10.23 10.23 10.23 0 0 1-10.23 10.23zm0-28.75a10.24 10.24 0 1 1 10.23-10.24 10.24 10.24 0 0 1-10.23 10.24zm0-28.76a10.24 10.24 0 1 1 10.23-10.23 10.23 10.23 0 0 1-10.23 10.23zm0-28.75a10.24 10.24 0 1 1 10.23-10.24 10.23 10.23 0 0 1-10.23 10.24zm0-28.76a10.24 10.24 0 1 1 10.23-10.23 10.23 10.23 0 0 1-10.23 10.23zm0-28.75a10.24 10.24 0 1 1 10.23-10.24 10.23 10.23 0 0 1-10.23 10.24zM471 394.88a10.24 10.24 0 1 1 10.24-10.24A10.25 10.25 0 0 1 471 394.88zm0-28.76a10.24 10.24 0 1 1 10.24-10.23A10.24 10.24 0 0 1 471 366.12zm0-28.75a10.24 10.24 0 1 1 10.24-10.24A10.25 10.25 0 0 1 471 337.37zm0-28.76a10.24 10.24 0 1 1 10.24-10.23A10.24 10.24 0 0 1 471 308.61zm0-28.75a10.24 10.24 0 1 1 10.24-10.24A10.24 10.24 0 0 1 471 279.86zm0-28.76a10.24 10.24 0 1 1 10.24-10.23A10.24 10.24 0 0 1 471 251.1zm0-28.75a10.24 10.24 0 1 1 10.24-10.24A10.24 10.24 0 0 1 471 222.35zm22.16 186a10.24 10.24 0 1 1 10.24-10.23 10.23 10.23 0 0 1-10.21 10.28zm0-28.75a10.24 10.24 0 1 1 10.24-10.24 10.24 10.24 0 0 1-10.21 10.29zm0-28.76a10.24 10.24 0 1 1 10.24-10.23 10.23 10.23 0 0 1-10.21 10.28zm0-28.75a10.24 10.24 0 1 1 10.24-10.24 10.24 10.24 0 0 1-10.21 10.29zm0-28.76a10.24 10.24 0 1 1 10.24-10.23 10.23 10.23 0 0 1-10.21 10.28zm0-28.75a10.24 10.24 0 1 1 10.24-10.24 10.23 10.23 0 0 1-10.21 10.29zm0-28.76a10.24 10.24 0 1 1 10.24-10.23 10.23 10.23 0 0 1-10.21 10.28zm0-28.75a10.24 10.24 0 1 1 10.24-10.24 10.23 10.23 0 0 1-10.21 10.29zm21.34 187.76a10.24 10.24 0 1 1 10.23-10.24 10.24 10.24 0 0 1-10.2 10.29zM535 408.4a10.24 10.24 0 1 1 10.23-10.23A10.23 10.23 0 0 1 535 408.4zm0-28.75a10.24 10.24 0 1 1 10.23-10.24A10.24 10.24 0 0 1 535 379.65zm0-28.76a10.24 10.24 0 1 1 10.23-10.23A10.23 10.23 0 0 1 535 350.89zm0-28.75a10.24 10.24 0 1 1 10.23-10.24A10.24 10.24 0 0 1 535 322.14zm0-28.76a10.24 10.24 0 1 1 10.23-10.23A10.23 10.23 0 0 1 535 293.38zm0-28.75a10.24 10.24 0 1 1 10.23-10.24A10.23 10.23 0 0 1 535 264.63zm0-28.76a10.24 10.24 0 1 1 10.23-10.23A10.23 10.23 0 0 1 535 235.87zm0-28.75a10.24 10.24 0 1 1 10.23-10.24A10.23 10.23 0 0 1 535 207.12z",
    fill: "#16a99e"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.24,
    cy: 398.17,
    r: 10.24,
    transform: "rotate(-13.28 69.263 398.25)",
    fill: "#6ab4e5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.24,
    cy: 369.41,
    r: 10.24,
    transform: "rotate(-9.22 69.206 369.317)",
    fill: "#6ab4e5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.24,
    cy: 340.66,
    r: 10.24,
    transform: "rotate(-9.22 69.217 340.546)",
    fill: "#6ab4e5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.24,
    cy: 311.9,
    r: 10.24,
    transform: "rotate(-45 69.246 311.907)",
    fill: "#6ab4e5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.24,
    cy: 283.15,
    r: 10.24,
    transform: "rotate(-9.22 69.233 283.066)",
    fill: "#6ab4e5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.24,
    cy: 254.39,
    r: 10.24,
    transform: "rotate(-45 69.241 254.39)",
    fill: "#6ab4e5"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.24,
    cy: 225.64,
    r: 10.24,
    transform: "rotate(-9.22 69.25 225.586)",
    fill: "#6ab4e5"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.24,
    cy: 196.88,
    r: 10.24,
    transform: "rotate(-13.28 69.28 196.912)",
    fill: "#6ab4e5"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.58,
    cy: 384.64,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.58,
    cy: 355.89,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.58,
    cy: 327.13,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.58,
    cy: 298.38,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.58,
    cy: 269.62,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.58,
    cy: 240.87,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.58,
    cy: 212.11,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.05,
    cy: 398.17,
    r: 10.24,
    transform: "rotate(-13.28 111.056 398.24)",
    fill: "#6ab4e5"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.05,
    cy: 369.41,
    r: 10.24,
    transform: "rotate(-9.22 111.022 369.319)",
    fill: "#6ab4e5"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.05,
    cy: 340.66,
    r: 10.24,
    transform: "rotate(-9.22 111.032 340.548)",
    fill: "#6ab4e5"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.05,
    cy: 311.9,
    r: 10.24,
    transform: "rotate(-45 111.053 311.9)",
    fill: "#6ab4e5"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.05,
    cy: 283.15,
    r: 10.24,
    transform: "rotate(-9.22 110.987 283.063)",
    fill: "#6ab4e5"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.05,
    cy: 254.39,
    r: 10.24,
    transform: "rotate(-45 111.044 254.394)",
    fill: "#6ab4e5"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.05,
    cy: 225.64,
    r: 10.24,
    transform: "rotate(-9.22 111.003 225.582)",
    fill: "#6ab4e5"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.05,
    cy: 196.88,
    r: 10.24,
    transform: "rotate(-13.28 111.073 196.901)",
    fill: "#6ab4e5"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.38,
    cy: 384.64,
    r: 10.24,
    transform: "rotate(-13.28 132.396 384.704)",
    fill: "#6ab4e5"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.38,
    cy: 355.89,
    r: 10.24,
    transform: "rotate(-9.22 132.333 355.809)",
    fill: "#6ab4e5"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.38,
    cy: 327.13,
    r: 10.24,
    transform: "rotate(-13.28 132.43 327.2)",
    fill: "#6ab4e5"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.38,
    cy: 298.38,
    r: 10.24,
    transform: "rotate(-9.22 132.349 298.328)",
    fill: "#6ab4e5"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.38,
    cy: 269.62,
    r: 10.24,
    transform: "rotate(-13.28 132.42 269.692)",
    fill: "#6ab4e5"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.38,
    cy: 240.87,
    r: 10.24,
    transform: "rotate(-9.22 132.37 240.786)",
    fill: "#6ab4e5"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.38,
    cy: 212.11,
    r: 10.24,
    transform: "rotate(-45 132.378 212.107)",
    fill: "#6ab4e5"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.99,
    cy: 398.17,
    r: 10.24,
    transform: "rotate(-13.28 152.023 398.22)",
    fill: "#6ab4e5"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.99,
    cy: 369.41,
    r: 10.24,
    transform: "rotate(-9.22 151.965 369.312)",
    fill: "#6ab4e5"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.99,
    cy: 340.66,
    r: 10.24,
    transform: "rotate(-9.22 151.975 340.541)",
    fill: "#6ab4e5"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.99,
    cy: 311.9,
    r: 10.24,
    transform: "rotate(-45 151.994 311.902)",
    fill: "#6ab4e5"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.99,
    cy: 283.15,
    r: 10.24,
    transform: "rotate(-9.22 151.93 283.056)",
    fill: "#6ab4e5"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.99,
    cy: 254.39,
    r: 10.24,
    transform: "rotate(-45 151.99 254.384)",
    fill: "#6ab4e5"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.99,
    cy: 225.64,
    r: 10.24,
    transform: "rotate(-9.22 151.946 225.576)",
    fill: "#6ab4e5"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.99,
    cy: 196.88,
    r: 10.24,
    transform: "rotate(-13.28 152.035 196.925)",
    fill: "#6ab4e5"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.32,
    cy: 384.64,
    r: 10.24,
    transform: "rotate(-13.28 173.358 384.727)",
    fill: "#6ab4e5"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.32,
    cy: 355.89,
    r: 10.24,
    transform: "rotate(-9.22 173.275 355.802)",
    fill: "#6ab4e5"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.32,
    cy: 327.13,
    r: 10.24,
    transform: "rotate(-13.28 173.353 327.176)",
    fill: "#6ab4e5"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.32,
    cy: 298.38,
    r: 10.24,
    transform: "rotate(-9.22 173.292 298.322)",
    fill: "#6ab4e5"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.32,
    cy: 269.62,
    r: 10.24,
    transform: "rotate(-13.28 173.344 269.668)",
    fill: "#6ab4e5"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.32,
    cy: 240.87,
    r: 10.24,
    transform: "rotate(-9.22 173.251 240.775)",
    fill: "#6ab4e5"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.32,
    cy: 212.11,
    r: 10.24,
    transform: "rotate(-45 173.318 212.11)",
    fill: "#6ab4e5"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.8,
    cy: 398.17,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.8,
    cy: 369.41,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.8,
    cy: 340.66,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.8,
    cy: 311.9,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.8,
    cy: 283.15,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.8,
    cy: 254.39,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.8,
    cy: 225.64,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.8,
    cy: 196.88,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.13,
    cy: 384.64,
    r: 10.24,
    transform: "rotate(-13.28 215.194 384.722)",
    fill: "#6ab4e5"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.13,
    cy: 355.89,
    r: 10.24,
    transform: "rotate(-9.22 215.091 355.804)",
    fill: "#6ab4e5"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.13,
    cy: 327.13,
    r: 10.24,
    transform: "rotate(-13.28 215.19 327.17)",
    fill: "#6ab4e5"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.13,
    cy: 298.38,
    r: 10.24,
    transform: "rotate(-9.22 215.046 298.318)",
    fill: "#6ab4e5"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.13,
    cy: 269.62,
    r: 10.24,
    transform: "rotate(-13.28 215.18 269.662)",
    fill: "#6ab4e5"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.13,
    cy: 240.87,
    r: 10.24,
    transform: "rotate(-9.22 215.067 240.776)",
    fill: "#6ab4e5"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.13,
    cy: 212.11,
    r: 10.24,
    transform: "rotate(-45 215.12 212.114)",
    fill: "#6ab4e5"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.59,
    cy: 398.17,
    r: 10.24,
    transform: "rotate(-45 235.583 398.158)",
    fill: "#6ab4e5"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.59,
    cy: 369.41,
    r: 10.24,
    transform: "rotate(-67.5 235.589 369.413)",
    fill: "#6ab4e5"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.59,
    cy: 340.66,
    r: 10.24,
    transform: "rotate(-67.5 235.591 340.655)",
    fill: "#6ab4e5"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.59,
    cy: 311.9,
    r: 10.24,
    transform: "rotate(-13.28 235.635 311.963)",
    fill: "#6ab4e5"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.59,
    cy: 283.15,
    r: 10.24,
    transform: "rotate(-67.5 235.584 283.143)",
    fill: "#6ab4e5"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.59,
    cy: 254.39,
    r: 10.24,
    transform: "rotate(-13.28 235.631 254.412)",
    fill: "#6ab4e5"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.59,
    cy: 225.64,
    r: 10.24,
    transform: "rotate(-67.5 235.584 225.636)",
    fill: "#6ab4e5"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.59,
    cy: 196.88,
    r: 10.24,
    transform: "rotate(-45 235.584 196.888)",
    fill: "#6ab4e5"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.92,
    cy: 384.64,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.92,
    cy: 355.89,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.92,
    cy: 327.13,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.92,
    cy: 298.38,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.92,
    cy: 269.62,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.92,
    cy: 240.87,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.92,
    cy: 212.11,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.39,
    cy: 398.17,
    r: 10.24,
    transform: "rotate(-45 277.385 398.163)",
    fill: "#6ab4e5"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.39,
    cy: 369.41,
    r: 10.24,
    transform: "rotate(-67.5 277.393 369.409)",
    fill: "#6ab4e5"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.39,
    cy: 340.66,
    r: 10.24,
    transform: "rotate(-67.5 277.39 340.659)",
    fill: "#6ab4e5"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.39,
    cy: 311.9,
    r: 10.24,
    transform: "rotate(-13.28 277.429 311.953)",
    fill: "#6ab4e5"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.39,
    cy: 283.15,
    r: 10.24,
    transform: "rotate(-67.5 277.39 283.152)",
    fill: "#6ab4e5"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.39,
    cy: 254.39,
    r: 10.24,
    transform: "rotate(-13.28 277.462 254.45)",
    fill: "#6ab4e5"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.39,
    cy: 225.64,
    r: 10.24,
    transform: "rotate(-67.5 277.396 225.637)",
    fill: "#6ab4e5"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.39,
    cy: 196.88,
    r: 10.24,
    transform: "rotate(-45 277.39 196.881)",
    fill: "#6ab4e5"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.72,
    cy: 384.64,
    r: 10.24,
    transform: "rotate(-67.5 298.721 384.645)",
    fill: "#6ab4e5"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.72,
    cy: 355.89,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.72,
    cy: 327.13,
    r: 10.24,
    transform: "rotate(-67.5 298.726 327.13)",
    fill: "#6ab4e5"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.72,
    cy: 298.38,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.72,
    cy: 269.62,
    r: 10.24,
    transform: "rotate(-67.5 298.727 269.623)",
    fill: "#6ab4e5"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.72,
    cy: 240.87,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.72,
    cy: 212.11,
    r: 10.24,
    transform: "rotate(-9.22 298.642 212.065)",
    fill: "#6ab4e5"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.59,
    cy: 398.17,
    r: 10.24,
    transform: "rotate(-45 322.596 398.166)",
    fill: "#6ab4e5"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.59,
    cy: 369.41,
    r: 10.24,
    transform: "rotate(-67.5 322.592 369.411)",
    fill: "#6ab4e5"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.59,
    cy: 340.66,
    r: 10.24,
    transform: "rotate(-67.5 322.595 340.654)",
    fill: "#6ab4e5"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.59,
    cy: 311.9,
    r: 10.24,
    transform: "rotate(-13.28 322.66 311.95)",
    fill: "#6ab4e5"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.59,
    cy: 283.15,
    r: 10.24,
    transform: "rotate(-67.5 322.595 283.147)",
    fill: "#6ab4e5"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.59,
    cy: 254.39,
    r: 10.24,
    transform: "rotate(-13.28 322.65 254.442)",
    fill: "#6ab4e5"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.59,
    cy: 225.64,
    r: 10.24,
    transform: "rotate(-67.5 322.595 225.64)",
    fill: "#6ab4e5"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.59,
    cy: 196.88,
    r: 10.24,
    transform: "rotate(-45 322.59 196.879)",
    fill: "#6ab4e5"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.92,
    cy: 384.64,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.92,
    cy: 355.89,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.92,
    cy: 327.13,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.92,
    cy: 298.38,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.92,
    cy: 269.62,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.92,
    cy: 240.87,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.92,
    cy: 212.11,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.4,
    cy: 398.17,
    r: 10.24,
    transform: "rotate(-45 364.398 398.171)",
    fill: "#6ab4e5"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.4,
    cy: 369.41,
    r: 10.24,
    transform: "rotate(-67.5 364.397 369.408)",
    fill: "#6ab4e5"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.4,
    cy: 340.66,
    r: 10.24,
    transform: "rotate(-67.5 364.394 340.658)",
    fill: "#6ab4e5"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.4,
    cy: 311.9,
    r: 10.24,
    transform: "rotate(-13.28 364.453 311.94)",
    fill: "#6ab4e5"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.4,
    cy: 283.15,
    r: 10.24,
    transform: "rotate(-67.5 364.4 283.143)",
    fill: "#6ab4e5"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.4,
    cy: 254.39,
    r: 10.24,
    transform: "rotate(-13.28 364.486 254.437)",
    fill: "#6ab4e5"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.4,
    cy: 225.64,
    r: 10.24,
    transform: "rotate(-67.5 364.4 225.635)",
    fill: "#6ab4e5"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.4,
    cy: 196.88,
    r: 10.24,
    transform: "rotate(-45 364.392 196.884)",
    fill: "#6ab4e5"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.73,
    cy: 384.64,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.73,
    cy: 355.89,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.73,
    cy: 327.13,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.73,
    cy: 298.38,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.73,
    cy: 269.62,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.73,
    cy: 240.87,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.73,
    cy: 212.11,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.89,
    cy: 398.17,
    r: 10.24,
    transform: "rotate(-13.28 407.996 398.242)",
    fill: "#6ab4e5"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.89,
    cy: 369.41,
    r: 10.24,
    transform: "rotate(-9.22 407.788 369.344)",
    fill: "#6ab4e5"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.89,
    cy: 340.66,
    r: 10.24,
    transform: "rotate(-9.22 407.8 340.573)",
    fill: "#6ab4e5"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.89,
    cy: 311.9,
    r: 10.24,
    transform: "rotate(-45 407.895 311.904)",
    fill: "#6ab4e5"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.89,
    cy: 283.15,
    r: 10.24,
    transform: "rotate(-9.22 407.754 283.088)",
    fill: "#6ab4e5"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.89,
    cy: 254.39,
    r: 10.24,
    transform: "rotate(-45 407.89 254.386)",
    fill: "#6ab4e5"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.89,
    cy: 225.64,
    r: 10.24,
    transform: "rotate(-9.22 407.77 225.608)",
    fill: "#6ab4e5"
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.89,
    cy: 196.88,
    r: 10.24,
    transform: "rotate(-13.28 407.97 196.898)",
    fill: "#6ab4e5"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 429.23,
    cy: 384.64,
    r: 10.24,
    transform: "rotate(-13.28 429.335 384.706)",
    fill: "#6ab4e5"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 429.23,
    cy: 355.89,
    r: 10.24,
    transform: "rotate(-9.22 429.104 355.772)",
    fill: "#6ab4e5"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 429.23,
    cy: 327.13,
    r: 10.24,
    transform: "rotate(-13.28 429.326 327.198)",
    fill: "#6ab4e5"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 429.23,
    cy: 298.38,
    r: 10.24,
    transform: "rotate(-9.22 429.12 298.292)",
    fill: "#6ab4e5"
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 429.23,
    cy: 269.62,
    r: 10.24,
    transform: "rotate(-13.28 429.321 269.646)",
    fill: "#6ab4e5"
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 429.23,
    cy: 240.87,
    r: 10.24,
    transform: "rotate(-9.22 429.075 240.807)",
    fill: "#6ab4e5"
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 429.23,
    cy: 212.11,
    r: 10.24,
    transform: "rotate(-45 429.22 212.111)",
    fill: "#6ab4e5"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 449.7,
    cy: 398.17,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 449.7,
    cy: 369.41,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 449.7,
    cy: 340.66,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 449.7,
    cy: 311.9,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 449.7,
    cy: 283.15,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 449.7,
    cy: 254.39,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 449.7,
    cy: 225.64,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 449.7,
    cy: 196.88,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 471.03,
    cy: 384.64,
    r: 10.24,
    transform: "rotate(-13.28 471.128 384.695)",
    fill: "#6ab4e5"
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 471.03,
    cy: 355.89,
    r: 10.24,
    transform: "rotate(-67.5 471.031 355.885)",
    fill: "#6ab4e5"
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 471.03,
    cy: 327.13,
    r: 10.24,
    transform: "rotate(-13.28 471.119 327.187)",
    fill: "#6ab4e5"
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 471.03,
    cy: 298.38,
    r: 10.24,
    transform: "rotate(-67.5 471.031 298.378)",
    fill: "#6ab4e5"
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 471.03,
    cy: 269.62,
    r: 10.24,
    transform: "rotate(-13.28 471.11 269.679)",
    fill: "#6ab4e5"
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 471.03,
    cy: 240.87,
    r: 10.24,
    transform: "rotate(-67.5 471.032 240.87)",
    fill: "#6ab4e5"
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 471.03,
    cy: 212.11,
    r: 10.24,
    transform: "rotate(-45 471.022 212.116)",
    fill: "#6ab4e5"
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 493.19,
    cy: 398.17,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 493.19,
    cy: 369.41,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 493.19,
    cy: 340.66,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 493.19,
    cy: 311.9,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 493.19,
    cy: 283.15,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 493.19,
    cy: 254.39,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 493.19,
    cy: 225.64,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 493.19,
    cy: 196.88,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 514.53,
    cy: 384.64,
    r: 10.24,
    transform: "rotate(-45 514.522 384.638)",
    fill: "#6ab4e5"
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 514.53,
    cy: 355.89,
    r: 10.24,
    transform: "rotate(-67.5 514.523 355.884)",
    fill: "#6ab4e5"
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 514.53,
    cy: 327.13,
    r: 10.24,
    transform: "rotate(-45 514.525 327.137)",
    fill: "#6ab4e5"
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 514.53,
    cy: 298.38,
    r: 10.24,
    transform: "rotate(-67.5 514.523 298.376)",
    fill: "#6ab4e5"
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    cx: 514.53,
    cy: 269.62,
    r: 10.24,
    transform: "rotate(-45 514.532 269.624)",
    fill: "#6ab4e5"
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    cx: 514.53,
    cy: 240.87,
    r: 10.24,
    transform: "rotate(-67.5 514.523 240.869)",
    fill: "#6ab4e5"
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    cx: 514.53,
    cy: 212.11,
    r: 10.24,
    transform: "rotate(-13.28 514.636 212.145)",
    fill: "#6ab4e5"
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    cx: 535,
    cy: 398.17,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    cx: 535,
    cy: 369.41,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    cx: 535,
    cy: 340.66,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    cx: 535,
    cy: 311.9,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    cx: 535,
    cy: 283.15,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    cx: 535,
    cy: 254.39,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    cx: 535,
    cy: 225.64,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    cx: 535,
    cy: 196.88,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.33,
    cy: 384.64,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.33,
    cy: 355.89,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.33,
    cy: 327.13,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle177 || (_circle177 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.33,
    cy: 298.38,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle178 || (_circle178 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.33,
    cy: 269.62,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle179 || (_circle179 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.33,
    cy: 240.87,
    r: 10.24,
    fill: "#6ab4e5"
  })), _circle180 || (_circle180 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.33,
    cy: 212.11,
    r: 10.24,
    fill: "#6ab4e5"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBubbleWrap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bubble_wrap.b6e0d977.svg";
export { ForwardRef as ReactComponent };